// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__s4MoZ","disabled_btn":"Button_disabled_btn__a5xpr"};